import { stringify } from 'qs';
import request from '@/utils/request';

export async function query(payload) {
  return request(`/iwms-account/account/company/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function save(payload) {
  return request(`/iwms-account/account/company`, {
    method: 'POST',
    body: payload,
  });
}

export async function modify(payload) {
  return request(`/iwms-account/account/company/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function updateReportConfig(payload) {
  return request(`/iwms-account/account/company/updateReportConfig?uuid=${payload.uuid}`, {
    method: 'POST',
    body: payload.param,
  });
}

export async function enable(payload) {
  return request(`/iwms-account/account/company/${payload.uuid}/enable?version=${payload.version}`, {
    method: 'POST',
  });
}

export async function disable(payload) {
  return request(`/iwms-account/account/company/${payload.uuid}/disable?version=${payload.version}`, {
    method: 'POST',
  });
}

export async function authorize(payload) {
  return request(`/iwms-account/account/company/${payload.uuid}/authorize?version=${payload.version}&orgType=${payload.orgType}`, {
    method: 'POST',
    body: payload.resources
  });
}

export async function testauthorize(payload) {
  return request(`/iwms-account/account/company/${payload.uuid}/testauthorize?version=${payload.version}&orgType=${payload.orgType}&display=${payload.display}`, {
    method: 'POST',
    body: payload.resources
  });
}

export async function get(uuid) {
  return request(`/iwms-account/account/company/${uuid}`);
}

export async function getByUuid32(uuid32) {
  return request(`/iwms-account/account/company/${uuid32}/uuid32`);
}

export async function getByCode(code) {
  return request(`/iwms-account/account/company/${code}/code`);
}

export async function getResourceKeys(uuid) {
  return request(`/iwms-account/account/company/${uuid}/resourceKeys`);
}

export async function getResources(uuid) {
  return request(`/iwms-account/account/company/${uuid}/resources`);
}

export async function saveAndAuthorize(payload){
  return request(`/iwms-account/account/company/saveAndAuthorize`, {
    method: 'POST',
    body: payload,
  });
}

export async function batchimport(payload){
  return request(`/iwms-account/account/menu/batchimport`,{
    method:'POST',
    body:payload
  })
}

export async function saveMenu(payload){
  return request(`/iwms-account/account/menu/${loginCompany().uuid}`,{
    method:'POST',
    body:payload
  })
}

export async function queryMenu(payload){
  return request(`/iwms-account/account/menu/query/${payload.uuid}`,{
    method:'GET'
  })
}

export async function queryreport(payload){
  return request(`/iwms-account/account/menu/queryreport`,{
    method:'GET'
  })
}

export async function getTestresourceKeys(uuid) {
  return request(`/iwms-account/account/company/${uuid}/testresourceKeys`);
}

export async function batchexport(payload){
  return request(`/iwms-account/account/menu/batchexport/${payload.uuid}`,{
    method: 'GET',
    responseType: 'blob'
  });
}


export async function permissionBatchExport(payload){
  return request(`/iwms-account/account/company/batchExport?companyUuid=${payload.companyUuid}`,{
    method: 'GET',
  });
}

//excel 批量权限信息导入
export async function permissionBatchImport(payload) {
  return request(`/iwms-account/account/company/batchImport?companyUuid=${payload.companyUuid}&fileKey=${payload.fileKey}`, {
    method: 'POST',
  });
}
